<mat-button-toggle-group>
    <mat-button-toggle
        *ngFor="let sheet of sheetPreviewMap.keys()"
        value="{{ sheet }}"
        (click)="onButtonToggleClick(sheet)"
        >{{ sheet }}</mat-button-toggle
    >
</mat-button-toggle-group>
<div class="spread-sheet-preview-container">
    <mat-table [dataSource]="dataSource" class="[customClass]">
        <ng-container
            *ngFor="let column of getColumnNames(sheetColumnsMap.get(currentSheet)); let columnNo = index"
            matColumnDef="{{ column }}"
        >
            <mat-cell
                *matCellDef="let row"
                (click)="onCellClick(row['column0'], columnNo)"
                [ngClass]="{
                    center: columnNo > 0 ? false : true,
                    number: sheetColumnsClassMap.get(column) == 'number' ? true : false
                }"
            >
                {{ row[column] }}
            </mat-cell>
        </ng-container>

        <mat-row
            *matRowDef="let row; columns: getColumnNames(sheetColumnsMap.get(currentSheet))"
            [ngClass]="{ 'highlighted-row': isRowExcluded(row), 'matching-error': hasMatchingErrors(row) }"
        ></mat-row>
    </mat-table>
</div>
